module.exports = __webpack_public_path__ + "static/media/stop-sales-items.9cf2918f.svg";